import { For, Show } from "solid-js";
import { css } from "styled-system/css";
import { Box } from "styled-system/jsx";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

function Paragraph(props: { text: string }) {
  const parts = () => props.text.split(URL_REGEX);

  return (
    <p>
      <For each={parts()}>
        {(part) => (
          <Show when={URL_REGEX.test(part)} fallback={<>{part}</>}>
            <a
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              class={css({ color: 'editorialAccentDeep', textDecoration: 'underline', textUnderlineOffset: '2px', wordBreak: 'break-word' })}
            >
              {part}
            </a>
          </Show>
        )}
      </For>
    </p>
  );
}

export default function Body(props: { content: string }) {
  const paragraphs = () => props.content.split(/\n+/).filter(Boolean);

  return (
    <Box
      py="24px"
      style={{ 'font-family': "'Newsreader', Georgia, serif" }}
      fontSize="19px"
      lineHeight="1.72"
      color="editorialInk"
      class={css({ '& p': { marginBottom: '22px' } })}
    >
      <For each={paragraphs()}>
        {(p) => <Paragraph text={p} />}
      </For>
    </Box>
  );
}
